import { Badge, BadgeProps } from "@chakra-ui/react";
import { BrandRetailerStatus } from "__generated__/gql/graphql";
import { BRAND_RETAILER_STATUS_LABELS } from "./utils";

const VARIANT: Record<BrandRetailerStatus, BadgeProps["variant"]> = {
  [BrandRetailerStatus.PROSPECTIVE]: "outline",
  [BrandRetailerStatus.APPROVED]: "outline",
  [BrandRetailerStatus.CURRENT]: "solid",
  [BrandRetailerStatus.INACTIVE]: "subtle",
};

const COLOR_SCHEME: Record<BrandRetailerStatus, BadgeProps["colorScheme"]> = {
  [BrandRetailerStatus.PROSPECTIVE]: "gray",
  [BrandRetailerStatus.APPROVED]: "green",
  [BrandRetailerStatus.CURRENT]: "green",
  [BrandRetailerStatus.INACTIVE]: "gray",
};

type Props = Omit<BadgeProps, "children"> & {
  status: BrandRetailerStatus;
};

export default function BrandRetailerStatusBadge({ status, ...rest }: Props) {
  return (
    <Badge
      variant={VARIANT[status]}
      colorScheme={COLOR_SCHEME[status]}
      {...rest}
      sx={{
        ...rest.sx,
        "tr[aria-selected=true] &": {
          "--badge-color": "white",
        },
      }}
    >
      {BRAND_RETAILER_STATUS_LABELS[status]}
    </Badge>
  );
}
